import React, { Suspense, lazy } from "react";
import "./App.css";

import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import Loader from "./Util/Loader/Loader";
// import Header from "./Util/Header/Header";

const Login = lazy(() =>
  import(/* webpackChunkName: "Login" */ "./Login/Login")
);

const Dashboard = lazy(() =>
  import(/* webpackChunkName: "Dashboard" */ "./Dashboard/Dashboard")
);

const DetailView = lazy(() =>
  import(/* webpackChunkName: "DetailView" */ "./DetailView/DetailView")
);
const Invoice = lazy(() =>
  import(/* webpackChunkName: "Invoice" */ "./Invoice/Invoice")
);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ffb300",
    },
    secondary: {
      main: "#161616",
    },
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }
          >
            {/* <Header history={this.customHistory} /> */}
            <Switch>
              <Route exact path="/" component={Login}></Route>
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/detail-view" component={DetailView} />
              <Route path="/invoice/:id" component={Invoice} />
              <Route component={Login} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
